import React from 'react';

import { useIframeAuth } from '../contexts/IframeAuthContext';

interface IframeLoadingProps {
  showFallback?: boolean;
}

export const IframeLoading: React.FC<IframeLoadingProps> = ({ showFallback = true }) => {
  const { iframeAuthStatus, iframeError } = useIframeAuth();

  const statusMessage = (() => {
    switch (iframeAuthStatus) {
      case 'requesting':
        return 'Requesting authentication...';
      case 'authenticating':
        return 'Authenticating user...';
      case 'error':
        return `Authentication failed: ${iframeError}`;
      default:
        return 'Initializing...';
    }
  })();

  const statusColor = (() => {
    switch (iframeAuthStatus) {
      case 'error':
        return '#dc3545';
      case 'success':
        return '#28a745';
      default:
        return '#007bff';
    }
  })();

  const handleFallbackToLogin = () => {
    if (window.parent !== window) {
      window.parent.location.href = window.location.href;
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        zIndex: 9999,
      }}
    >
      {iframeAuthStatus === 'error' ? (
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#dc3545',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <span style={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}>!</span>
        </div>
      ) : (
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: `4px solid ${statusColor}`,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '20px',
          }}
        />
      )}

      <h3
        style={{
          color: statusColor,
          marginBottom: '10px',
          textAlign: 'center',
        }}
      >
        {statusMessage}
      </h3>

      {iframeAuthStatus === 'error' && (
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px',
              marginRight: showFallback ? '10px' : 0,
            }}
          >
            Retry
          </button>

          {showFallback && (
            <button
              onClick={handleFallbackToLogin}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
            >
              Use Standard Login
            </button>
          )}
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
